<ng-container *transloco="let t">
    <h1>{{ t("account.tab.personal-information") }}</h1>
    <form
        [formGroup]="personalInformation"
        fxLayout="column"
        (ngSubmit)="onSubmit($event)"
        fxLayoutGap="15px"
    >
        <input type="hidden" formControlName="userId" required />

        <!-- #region FIRST NAME -->
        <mat-form-field appearance="outline">
            <mat-label>{{ t("shared.field.first-name") }}</mat-label>
            <input matInput formControlName="firstName" maxlength="50" />
            <mat-error *ngIf="firstName?.hasError('required')"
                >{{ t("shared.error.required.first-name") }}
            </mat-error>
        </mat-form-field>
        <!-- #endregion -->

        <!-- #region LAST NAME -->
        <mat-form-field appearance="outline">
            <mat-label>{{ t("shared.field.last-name") }}</mat-label>
            <input matInput formControlName="lastName" maxlength="50" />
            <mat-error *ngIf="lastName?.hasError('required')">{{
                t("shared.error.required.last-name")
            }}</mat-error>
        </mat-form-field>
        <!-- #endregion -->

        <!-- #region EMAIL OR PHONE -->
        <mat-form-field appearance="outline">
            <mat-label>{{ t("auth.login.emailOrPhone") }}</mat-label>
            <input
                matInput
                formControlName="emailOrPhoneNumber"
                maxlength="200"
            />
            <mat-error *ngIf="emailOrPhoneNumber?.hasError('required')">
                {{ t("auth.account-setup.emailOrPhoneRequired") }}
            </mat-error>
            <mat-error
                *ngIf="
                    emailOrPhoneNumber?.hasError('invalidEmailOrPhoneNumber')
                "
            >
                {{ t("auth.account-setup.invalidEmailOrPhoneNumber") }}
            </mat-error>
        </mat-form-field>
        <!-- #endregion -->

        <!-- #region PREFERRED LANGUAGE -->
        <div>
            <h4>{{ t("shared.group.preferred-language") }}</h4>
            <mat-radio-group
                color="primary"
                aria-label="Select preferred written language"
                formControlName="preferredLanguageId"
                required
            >
                <mat-radio-button
                    *ngFor="let language of languages$ | async"
                    [value]="language.languageId"
                    >{{ language.nativeName }}</mat-radio-button
                >
            </mat-radio-group>
            <mat-error *ngIf="preferredLanguageId?.hasError('required')"
                >{{ t("shared.error.required.preferred-language") }}
            </mat-error>
        </div>
        <!-- #endregion -->

        <div>
            <button mat-raised-button color="accent">
                {{ t("account.save-changes") }}
            </button>
        </div>
    </form>
</ng-container>
